// jquery
$(document).ready(() => {
  const isRTL = $('#content-wrapper').attr('dir') === 'rtl';
  const $wrapper = $(`.r7-socials`);
  const $list = $wrapper.find(`.r7-socials__list`);
  const $videoCards = $('#oc-container .r7-socials__item--video');
  let currentMedia = 'sm';

  let intersecting = false;
  $wrapper.observe(
    (evt) => {
      if (evt[0].isIntersecting) {
        intersecting = true;
        $videoCards.each((key, item) => {
          const $video = $(item).find('video');
          if ($(item).hasClass('slick-active')) {
            $video[0].play();
          }
        });
      } else {
        intersecting = false;
        $videoCards.each((key, item) => {
          const $video = $(item).find('video');
          $video[0].pause();
        });
      }
    },
    { threshold: 0 }
  );

  $videoCards.each((key, item) => {
    const $video = $(item).find('video');
    $video.on('canplay', () => {
      const $poster = $(item).find('.picture-container');
      $poster.fadeTo(0, 0);
    });
  });

  const setVideos = () => {
    const w = $(window).width();
    let newMedia = currentMedia;

    if (w >= 768 && currentMedia !== 'md') {
      newMedia = 'md';
    } else if (w < 768 && currentMedia !== 'sm') {
      newMedia = 'sm';
    }

    if (newMedia !== currentMedia) {
      currentMedia = newMedia;
      $videoCards.each((key, item) => {
        const $video = $(item).find('video');
        if ($video.length) {
          $video.attr('src', $video.data(`src-${currentMedia}`));
          $video[0].load();
        }
      });
    }
  };

  // $list.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
  //   if (intersecting && nextSlide !== currentSlide) {
  //     window.handleImpressionTracking($(slick.$slides[nextSlide]));
  //   }
  // });

  // init slick
  $list.slick({
    dots: true,
    appendDots: $wrapper.find('.r7-socials__controls'),
    arrows: false,
    customPaging: () => $('<button type="button" />'),
    infinite: false,
    variableWidth: true,
    centerMode: true,
    mobileFirst: true,
    rtl: isRTL,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: true,
          prevArrow: $wrapper.find('.r7-socials__prev'),
          nextArrow: $wrapper.find('.r7-socials__next'),
        },
      },
    ],
  });

  $list.on('afterChange', (event, slick, currentSlide, nextSlide) => {
    if (intersecting && nextSlide !== currentSlide) {
      $videoCards.each((key, item) => {
        const $item = $(item);
        const $video = $item.find('video');

        if ($item.hasClass('slick-center')) {
          $video[0].play();
        } else {
          $video[0].pause();
        }
      });
    }
  });

  setVideos();
  $(window).on('resize', () => {
    setVideos();
  });
});
